module.exports = __webpack_public_path__ + "static/media/MFA-Background-001.2a4982fe.png";